import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { levelType } from "./levelResourceConsts";

export const levelIdentifierStruct = createIdentifierStruct(levelType);
